export default __webpack_public_path__ + "static/O0087-628b6746c6a9651f3c3f3e0518d3c529.png";